<template>
  <div>
    <section class="mb-12 p-12">
      <p class="mx-4 text-gray-600 font-bold uppercase mb-4">Resumen</p>
      <ul class="border p-12 my-4">
        <li><b>Centro : </b> {{ $root.centro.title }}</li>
        <li>
          <b>Nombre completo : </b>
          {{ $root.alumno ? $root.alumno.nombre : "" }}
          {{ $root.alumno ? $root.alumno.apellidos : "" }}
        </li>
        <li>
          <b>ID Alumno : </b> {{ $root.alumno ? $root.alumno.ID_Alumno : "" }}
        </li>
        <li>
          <b>ID Curso : </b> {{ $root.alumno ? $root.alumno.ID_Curso : "" }}
        </li>
        <li>
          <b>Nombre Contacto : </b> {{ $root.form.nombre_contacto }}
          {{ $root.form.apellidos_contacto }}
        </li>
        <li><b>DNI contacto : </b> {{ $root.form.dni_contacto }}</li>
        <li><b>Email contacto : </b> {{ $root.form.email_contacto }}</li>
        <li><b>Teléfono contacto : </b> {{ $root.form.telefono_contacto }}</li>
        <li><b>Observaciones : </b> {{ $root.form.observaciones }}</li>
        <li>
          <b>Estado iCloud : </b>
          {{ $root.form.icloud }}
        </li>
        <li><b>Nombre comercial : </b> {{ $root.form.nombre_comercial }}</li>
        <li><b>Email comercial : </b> {{ $root.form.email_comercial }}</li>
      </ul>
      <p class="mx-4 text-gray-600 font-bold uppercase my-4">Dispositivo</p>
      <ul class="border-t pl-0 mb-12">
        <li
          class="flex justify-between border-b border-l font-bold bg-blue-400"
        >
          <div class="w-full flex items-center justify-center border-r p-4">
            Num. Serie
          </div>
          <div class="w-full flex items-center justify-center border-r p-4">
            Modelo Ipad
          </div>
          <div
            class="
              w-64
              flex-shrink-0 flex
              items-center
              justify-center
              border-r
              p-4
            "
          >
            Modelo Renove
          </div>
          <div
            class="
              w-32
              flex-shrink-0 flex
              items-center
              justify-center
              border-r
              p-4
            "
          >
            Funcional
          </div>
        </li>
        <li
          v-for="disp in $root.form.dispositivos"
          :key="disp.num"
          class="flex justify-between border-b border-l"
        >
          <div class="w-full flex items-center justify-center border-r p-4">
            {{ disp.numero_de_serie }}
          </div>
          <div class="w-full flex items-center justify-center border-r p-4">
            {{ disp.modelo }}
          </div>
          <div
            class="
              w-64
              flex-shrink-0 flex
              items-center
              justify-center
              border-r
              p-4
            "
          >
            {{ $root.form.modelo ? $root.form.modelo.modelo : "" }}
          </div>
          <div
            class="
              w-32
              flex-shrink-0 flex
              items-center
              justify-center
              border-r
              p-4
            "
          >
            <svg
              v-if="$root.form.funcional"
              class="svg-icon w-6 h-6 fill-current text-green-600"
              viewBox="0 0 20 20"
            >
              <path
                d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03"
              ></path>
            </svg>
            <svg
              v-else
              class="svg-icon w-6 h-6 fill-current text-red-600"
              viewBox="0 0 20 20"
            >
              <path
                d="M10.185,1.417c-4.741,0-8.583,3.842-8.583,8.583c0,4.74,3.842,8.582,8.583,8.582S18.768,14.74,18.768,10C18.768,5.259,14.926,1.417,10.185,1.417 M10.185,17.68c-4.235,0-7.679-3.445-7.679-7.68c0-4.235,3.444-7.679,7.679-7.679S17.864,5.765,17.864,10C17.864,14.234,14.42,17.68,10.185,17.68 M10.824,10l2.842-2.844c0.178-0.176,0.178-0.46,0-0.637c-0.177-0.178-0.461-0.178-0.637,0l-2.844,2.841L7.341,6.52c-0.176-0.178-0.46-0.178-0.637,0c-0.178,0.176-0.178,0.461,0,0.637L9.546,10l-2.841,2.844c-0.178,0.176-0.178,0.461,0,0.637c0.178,0.178,0.459,0.178,0.637,0l2.844-2.841l2.844,2.841c0.178,0.178,0.459,0.178,0.637,0c0.178-0.176,0.178-0.461,0-0.637L10.824,10z"
              ></path>
            </svg>
          </div>
        </li>
      </ul>
    </section>
    <v-flex justify-between>
      <v-btn text @click="$emit('change-step', step - 1)">Volver</v-btn>
      <v-btn color="primary" :loading="loading" @click="next"
        >Registrar y enviar por correo</v-btn
      >
    </v-flex>
  </div>
</template>

<script>
import { PDFDocument, StandardFonts } from "pdf-lib";

export default {
  name: "StepFour",

  props: {
    step: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      pdfBlob: null,
    };
  },

  methods: {
    async next() {
      this.loading = true;

      const formData = new FormData();

      formData.append("action", "enviarDatos");
      formData.append(
        "data",
        JSON.stringify({ alumno: this.$root.alumno, ...this.$root.form })
      );

      const contract = await this.generateContract();
      formData.append("contrato", contract);

      fetch("https://educacion.bananacomputer.com/indev.php", {
        method: "POST",
        headers: new Headers({
          "X-Hooks-Token": window.hooksToken,
        }),
        body: formData,
      })
        .then((response) => response.json())
        .then((json) => {
          if (json.success) {
            window.Sweetalert2.fire({
              type: "success",
              title: "¡Completado!",
              text: "Recogida confirmada y correo enviado.",
              confirmButtonText: "Descargar contrato",
              showCancelButton: true,
              cancelButtonText: "Cerrar",
              allowOutsideClick: false,
            }).then((result) => {
              if (Object.prototype.hasOwnProperty.call(result, "dismiss")) {
                window.location.reload();
              } else {
                this.downloadContract().then(() => {
                  window.Sweetalert2.fire({
                    type: "success",
                    title: "¡Completado!",
                    text: "Descarga completada.",
                  }).then(() => window.location.reload());
                });
              }
            });
          } else {
            this.showError();
          }
        })
        .catch(() => this.showError())
        .finally(() => (this.loading = false));
    },
    showError() {
      window.Sweetalert2.fire(
        "Oops..",
        "Hubo un error al registrar la recogida de equipo, por favor contacte con un técnico.",
        "error"
      );
    },
    generateContract() {
      const urlPath =
        "https://educacion.bananacomputer.com/cms/uploads/CONTRATO_RENOVE_JUNIO_2021.pdf";

      return fetch(urlPath)
        .then((response) => response.arrayBuffer())
        .then(async (buffer) => {
          const pdf = await PDFDocument.load(buffer);

          const helveticaFont = await pdf.embedFont(StandardFonts.Helvetica);

          const pages = pdf.getPages();
          const firstPage = pages[0];
          const { height } = firstPage.getSize();
          const xPosition = 165;
          const blockHeight = 23;
          const fontSize = 10;

          const content = [
            {
              text: new Date().toLocaleDateString("es-ES"),
              y: 144,
            },
            {
              text: `${this.$root.form.nombre_contacto} ${this.$root.form.apellidos_contacto}`,
              y: 167,
            },
            {
              text: this.$root.form.dni_contacto,
              y: 190,
            },
            {
              text: this.$root.form.modelo.modelo,
              y: 251,
            },
            {
              text: this.$root.form.dispositivos[0].numero_de_serie,
              y: 274,
            },
            {
              text: this.$root.form.funcional ? "Operativo" : "No funcional",
              y: 297,
            },
            {
              text: this.$root.form.funcional
                ? `${this.$root.form.modelo.precio_ok} €`
                : `${this.$root.form.modelo.precio_ko} €`,
              y: 320,
            },
          ];

          content.forEach((c) => {
            firstPage.drawText(c.text, {
              x: xPosition,
              y: height - c.y + (blockHeight - fontSize) / 2,
              size: fontSize,
              font: helveticaFont,
            });
          });

          const pdfBytes = await pdf.save();

          this.blob = new Blob([pdfBytes.buffer], {
            type: "application/pdf",
          });

          return this.blob;
        });
    },
    async downloadContract() {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(this.blob);
      link.download = "CONTRATO_RENOVE_JUNIO_2021.pdf";

      link.click();

      URL.revokeObjectURL(link.href);
    },
  },
};
</script>
